/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React from 'react';

const SvgIconBotAngry = props => {
  return (
    <svg viewBox="0 0 435 314" {...props} role="img" aria-hidden="true" focusable="false">
      <defs>
        <path id="illustration-angry-robot_svg__a" d="M0 0h222.581v145.052H0z" />
        <path id="illustration-angry-robot_svg__c" d="M.238.904h119.048v57.1H.238z" />
        <path id="illustration-angry-robot_svg__e" d="M0 0h222.581v112.818H0z" />
        <path
          d="M135.484 87.785c0-10.809 6.057-20.614 15.845-27.732 21.466-15.603 56.521-15.603 77.987 0 9.792 7.118 15.845 16.923 15.845 27.732 0 24.473-28.514 39.426-54.834 39.426-2.949 0-5.696-.181-8.613-.473l-31.391 15.09 6.753-22.637c-12.732-7.668-21.592-17.6-21.592-31.406"
          id="illustration-angry-robot_svg__h"
        />
        <path
          d="M61.29 112.867c0-7.081 3.92-13.505 10.253-18.169 13.89-10.223 36.573-10.223 50.462 0 6.336 4.664 10.253 11.088 10.253 18.17 0 16.033-18.45 25.83-35.481 25.83-1.908 0-3.686-.119-5.573-.31l-20.312 9.887 4.37-14.832c-8.239-5.023-13.972-11.53-13.972-20.576"
          id="illustration-angry-robot_svg__j"
        />
        <filter
          x="-23.7%"
          y="-13.9%"
          width="147.4%"
          height="155.6%"
          filterUnits="objectBoundingBox"
          id="illustration-angry-robot_svg__g"
        >
          <feOffset dy={13} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={6.5} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261063156 0" in="shadowBlurOuter1" />
        </filter>
        <filter
          x="-36.6%"
          y="-21.2%"
          width="173.3%"
          height="184.9%"
          filterUnits="objectBoundingBox"
          id="illustration-angry-robot_svg__i"
        >
          <feOffset dy={13} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={6.5} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.261063156 0" in="shadowBlurOuter1" />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <circle fill="#F2F2F2" cx={238} cy={152.667} r={136} />
        <g transform="translate(29.032 167.615)">
          <mask id="illustration-angry-robot_svg__b" fill="#fff">
            <use xlinkHref="#illustration-angry-robot_svg__a" />
          </mask>
          <path
            d="M61.711 122.027h78.267c2.123 0 2.893.222 3.669.637a4.327 4.327 0 011.8 1.8c.415.776.636 1.545.636 3.668v11.583c0 2.122-.221 2.892-.636 3.668a4.327 4.327 0 01-1.8 1.8c-.776.415-1.546.636-3.669.636H61.711c-2.122 0-2.892-.221-3.668-.636a4.327 4.327 0 01-1.8-1.8c-.415-.776-.636-1.546-.636-3.668v-11.583c0-2.123.22-2.892.636-3.668a4.327 4.327 0 011.8-1.8c.776-.415 1.546-.637 3.668-.637z"
            fill="#A03738"
            mask="url(#illustration-angry-robot_svg__b)"
          />
          <path
            d="M94.157-45.75h14.138c50.22 0 90.93 40.711 90.93 90.93v62.932c0 15.464-12.535 28-28 28h-140c-15.463 0-28-12.536-28-28V45.181c0-50.22 40.712-90.931 90.932-90.931z"
            fill="#EF6461"
            mask="url(#illustration-angry-robot_svg__b)"
          />
          <g mask="url(#illustration-angry-robot_svg__b)">
            <g transform="translate(44.155 35.32)">
              <mask id="illustration-angry-robot_svg__d" fill="#fff">
                <use xlinkHref="#illustration-angry-robot_svg__c" />
              </mask>
              <ellipse
                stroke="#FFF"
                strokeWidth={4.667}
                fill="#FFF"
                mask="url(#illustration-angry-robot_svg__d)"
                cx={59.952}
                cy={6.995}
                rx={44.333}
                ry={44.298}
              />
              <ellipse
                fill="#000"
                mask="url(#illustration-angry-robot_svg__d)"
                cx={59.952}
                cy={6.995}
                rx={23.333}
                ry={23.316}
              />
              <ellipse
                fill="#FFF"
                mask="url(#illustration-angry-robot_svg__d)"
                cx={69.19}
                cy={2.522}
                rx={9.333}
                ry={9.326}
              />
            </g>
          </g>
          <path
            stroke="#000"
            strokeWidth={14}
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#illustration-angry-robot_svg__b)"
            transform="rotate(-1.38 102.79 32.761)"
            d="M161.028 34.164L44.552 31.359"
          />
          <path
            d="M103.49-45.75c-50.22 0-90.93 40.711-90.93 90.93v62.932c0 15.464 12.535 28 28 28h-9.334c-15.464 0-28-12.536-28-28V45.181c0-50.22 40.711-90.931 90.931-90.931z"
            fill="#943E3C"
            mask="url(#illustration-angry-robot_svg__b)"
          />
        </g>
        <g transform="rotate(150 194.36 144.263)">
          <mask id="illustration-angry-robot_svg__f" fill="#fff">
            <use xlinkHref="#illustration-angry-robot_svg__e" />
          </mask>
          <g mask="url(#illustration-angry-robot_svg__f)">
            <path
              d="M130.854 19.62c-6.026 4.321-17.137 17.01-33.334 38.066l5.614 23.958"
              stroke="#000"
              strokeWidth={7}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <g transform="translate(105.452 6.447)">
              <ellipse fill="#000" cx={19.108} cy={18.653} rx={18.667} ry={18.653} />
              <ellipse fill="#EF6461" cx={19.108} cy={18.653} rx={9.333} ry={9.326} />
            </g>
            <path
              d="M61.711 234.845h78.267c2.123 0 2.893.221 3.669.636a4.327 4.327 0 011.8 1.8c.415.776.636 1.546.636 3.669v11.582c0 2.123-.221 2.893-.636 3.669a4.327 4.327 0 01-1.8 1.8c-.776.415-1.546.636-3.669.636H61.711c-2.122 0-2.892-.221-3.668-.636a4.327 4.327 0 01-1.8-1.8c-.415-.776-.636-1.546-.636-3.669V240.95c0-2.123.22-2.893.636-3.669a4.327 4.327 0 011.8-1.8c.776-.415 1.546-.636 3.668-.636z"
              fill="#A03738"
            />
            <path
              d="M94.157 67.068h14.138c50.22 0 90.93 40.71 90.93 90.93v62.932c0 15.464-12.535 28-28 28h-140c-15.463 0-28-12.536-28-28v-62.931c0-50.22 40.712-90.931 90.932-90.931z"
              fill="#EF6461"
            />
            <path
              d="M103.49 67.068c-50.22 0-90.93 40.71-90.93 90.93v62.932c0 15.464 12.535 28 28 28h-9.334c-15.464 0-28-12.536-28-28v-62.931c0-50.22 40.711-90.931 90.931-90.931z"
              fill="#943E3C"
            />
            <g strokeLinecap="round" strokeLinejoin="round" strokeWidth={14}>
              <path
                d="M145.549 129.936c-11.043 5.705-23.656 8.939-37.05 8.939-13.953 0-27.058-3.51-38.423-9.666"
                stroke="#000"
              />
              <path stroke="#FFF" d="M137.984 203.311l-60.712-44.806M78.115 204.41l59.026-47.003" />
            </g>
          </g>
        </g>
        <use fill="#000" filter="url(#illustration-angry-robot_svg__g)" xlinkHref="#illustration-angry-robot_svg__h" />
        <use fill="#EF6461" xlinkHref="#illustration-angry-robot_svg__h" />
        <g transform="matrix(-1 0 0 1 193.548 0)" fill="#000">
          <use filter="url(#illustration-angry-robot_svg__i)" xlinkHref="#illustration-angry-robot_svg__j" />
          <use xlinkHref="#illustration-angry-robot_svg__j" />
        </g>
        <path
          d="M81.42 119.806c.963 0 1.76-.33 2.393-.993.632-.662.948-1.504.948-2.527 0-1.023-.316-1.865-.948-2.527-.632-.662-1.43-.993-2.394-.993-.963 0-1.768.331-2.416.993-.647.662-.97 1.504-.97 2.527 0 1.023.323 1.865.97 2.527.648.662 1.453.993 2.416.993zm15.038 0c.964 0 1.761-.33 2.394-.993.632-.662.948-1.504.948-2.527 0-1.023-.316-1.865-.948-2.527-.633-.662-1.43-.993-2.394-.993-.963 0-1.769.331-2.416.993-.647.662-.971 1.504-.971 2.527 0 1.023.324 1.865.97 2.527.648.662 1.454.993 2.417.993zm15.039 0c.963 0 1.761-.33 2.393-.993.633-.662.949-1.504.949-2.527 0-1.023-.316-1.865-.949-2.527-.632-.662-1.43-.993-2.393-.993-.964 0-1.769.331-2.416.993-.648.662-.971 1.504-.971 2.527 0 1.023.323 1.865.97 2.527.648.662 1.453.993 2.417.993zM164 94.406c1.652 0 3.02-.567 4.103-1.702 1.084-1.135 1.626-2.579 1.626-4.332 0-1.754-.542-3.198-1.626-4.332-1.084-1.135-2.451-1.702-4.103-1.702-1.652 0-3.032.567-4.142 1.702-1.11 1.134-1.664 2.578-1.664 4.332 0 1.753.554 3.197 1.664 4.332 1.11 1.135 2.49 1.702 4.142 1.702zm25.78 0c1.652 0 3.02-.567 4.104-1.702s1.626-2.579 1.626-4.332c0-1.754-.542-3.198-1.626-4.332-1.084-1.135-2.452-1.702-4.103-1.702-1.652 0-3.033.567-4.142 1.702-1.11 1.134-1.665 2.578-1.665 4.332 0 1.753.555 3.197 1.665 4.332 1.11 1.135 2.49 1.702 4.142 1.702zm25.781 0c1.652 0 3.02-.567 4.104-1.702 1.083-1.135 1.625-2.579 1.625-4.332 0-1.754-.542-3.198-1.625-4.332-1.084-1.135-2.452-1.702-4.104-1.702-1.651 0-3.032.567-4.142 1.702-1.11 1.134-1.664 2.578-1.664 4.332 0 1.753.555 3.197 1.664 4.332 1.11 1.135 2.49 1.702 4.142 1.702z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export default SvgIconBotAngry;
